export interface IElementFactory {
    createElement(csvRow: Array<string>): string;
}

export class ImageElementFactory implements IElementFactory {
    srcColumnNum: number;
    altColumnNum: number;
    dataExpr = /data:\w+\/\w+/

    constructor(src: number, alt = -1) {
        this.srcColumnNum = src;
        this.altColumnNum = alt;
    }

    public createElement(csvRow: Array<string>): string {
        let value = '';
        let srcArray = csvRow[this.srcColumnNum].split(';');
        if (this.dataExpr.test(srcArray[0])) {
            srcArray = [csvRow[this.srcColumnNum]];
        }
        let altArray = new Array<string>();
        if (this.altColumnNum >= 0) {
            altArray = csvRow[this.altColumnNum].split(';');
        }
        let cell = '';
        for (let index = 0; index < srcArray.length; index++) {
            if (srcArray.length === altArray.length) {
                cell += `<img src='${srcArray[index]}' alt='${altArray[index]}'><br>`;
            } else {
                cell += `<img src='${srcArray[index]}' alt=''><br>`;
            }
        }
        return cell;
    }
}

export class LinkElementFactory implements IElementFactory {
    hrefColumnNum: number;
    textColumnNum: number;

    constructor(href: number, text = -1) {
        this.hrefColumnNum = href;
        this.textColumnNum = text;
    }

    public createElement(csvRow: Array<string>): string {
        let hrefArray = csvRow[this.hrefColumnNum].split(';');
        let textArray = new Array<string>();
        let cell = '';
        if (this.textColumnNum >= 0) {
            textArray = csvRow[this.textColumnNum].split(';');
        }
        for (let index = 0; index < hrefArray.length; index++) {
            if (hrefArray.length === textArray.length) {
                cell += `<a href='${hrefArray[index]}'>${textArray[index]}</a><br>`;
            } else {
                cell += `<a href='${hrefArray[index]}'>${hrefArray[index]}</a><br>`;
            }
        }
        return cell;
    }
}

export class TextElementFactory implements IElementFactory {
    textColumnNum: number;

    constructor(text: number) {
        this.textColumnNum = text;
    }

    public createElement(csvRow: Array<string>): string {
        let textArray = csvRow[this.textColumnNum].split(';');
        let cell = '';
        for (let index = 0; index < textArray.length; index++) {
            cell += `<span>${textArray[index]}</span><br>`;
        }
        return cell;
    }
}
